import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const StakeComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      className="nostra__icon nostra__icon__stake"
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 8.06061C8 3.22727 9.25 2.06061 14 2.06061C14 6.64394 12.5833 8.06061 8 8.06061Z"
        stroke={colorVar}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10.5606C8 5.72727 6.75 4.56061 2 4.56061C2 9.14394 3.41667 10.5606 8 10.5606Z"
        stroke={colorVar}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 7.06061V14.0606" stroke={colorVar} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const Stake = withIcon(StakeComponent);
